export class AwsAccountConfigInput {
    'roleArn';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsAccountConfigInput.attributeTypeMap;
    }
    constructor() {
    }
}
